<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import HoldIcon from './HoldIcon.vue';
  import ResumeIcon from './ResumeIcon.vue';

  defineProps<{
    isHold: boolean;
  }>();
</script>

<template>
  <call-action
    :title="isHold ? trans('voip.calls.call_action.resume_trans') : trans('voip.calls.call_action.hold_trans')"
  >
    <hold-icon v-if="!isHold" />
    <resume-icon v-else />
  </call-action>
</template>
